import { RoleEnum } from '../enums';
export class enums {
    static RoleToString(type: RoleEnum) {
        return this.ToString(String(RoleEnum[type]));
    }

    static ToString(s: string): string {
        s = s.replace('_', ' ');
        return s;
    }
}


// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/classes/enums.class.ts